module.exports = __webpack_public_path__ + "static/media/30-iveco-mercedes.c9efded5.jpg";